import {
	Component, Input, Output, EventEmitter, OnChanges, SimpleChanges,
	ChangeDetectorRef, ChangeDetectionStrategy, SimpleChange
} from '@angular/core';
import { ComponentBase } from 'common';
import { DiscResultsService } from 'discovery/services/discresults.service';
import { PrtgMapDto } from 'UvExplorerServer.Dtos.TS/Session/PrtgMapDto';

// Modal picker for browsing existing PRTG maps. Invoked from the
// Export-to-PRTG-Map dialog's Map Name "Browse..." button. Emits the chosen
// map's ID + name on (onSelect). Mirrors the WinForms PRTG Maps dialog (flat
// table with ID / Name / Tags columns).
@Component({
	selector: 'prtg-map-picker',
	templateUrl: './prtg-map-picker.component.html',
	styleUrls: ['./prtg-map-picker.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrtgMapPickerComponent extends ComponentBase implements OnChanges {

	@Input() public display: boolean;
	@Input() public netViewGuid: string;
	@Input() public prtgSettingsGuid: string;
	@Input() public title: string;

	@Output() public displayChange = new EventEmitter<boolean>();
	@Output() public onCancel = new EventEmitter<void>();
	@Output() public onSelect = new EventEmitter<{ id: number, name: string }>();

	public maps: PrtgMapDto[] = [];
	public selectedMap: PrtgMapDto | null = null;
	public loading: boolean = false;
	public errorMessage: string = "";

	constructor(
		private discResultsService: DiscResultsService,
		private changeDetector: ChangeDetectorRef) {
		super();
		this.display = false;
		this.netViewGuid = "";
		this.prtgSettingsGuid = "";
		this.title = "PRTG Maps";
	}

	public ngOnChanges(changes: SimpleChanges): void {
		const displayChange: SimpleChange = changes["display"];
		if (displayChange && displayChange.currentValue === true && this.netViewGuid && this.prtgSettingsGuid) {
			this.loadMaps();
		}
	}

	private loadMaps(): void {
		this.loading = true;
		this.errorMessage = "";
		this.maps = [];
		this.selectedMap = null;
		this.changeDetector.markForCheck();

		this.discResultsService.listPrtgMaps(this.netViewGuid, this.prtgSettingsGuid).subscribe(
			(rows: PrtgMapDto[]) => {
				this.loading = false;
				this.maps = rows || [];
				if (this.maps.length === 0) {
					this.errorMessage = "No PRTG maps returned by the server.";
				}
				this.changeDetector.markForCheck();
			},
			(error) => {
				this.loading = false;
				this.errorMessage = "Failed to load PRTG maps.";
				this.changeDetector.markForCheck();
			});
	}

	public get enableSelect(): boolean {
		return !this.loading && this.selectedMap != null;
	}

	public hide(): void {
		this.display = false;
		this.displayChange.emit(this.display);
		this.changeDetector.markForCheck();
	}

	public cancel(): void {
		this.hide();
		this.onCancel.emit();
	}

	public select(): void {
		if (!this.enableSelect || !this.selectedMap) return;
		const chosen = this.selectedMap;
		this.hide();
		this.onSelect.emit({ id: chosen.id, name: chosen.name });
	}

	public onRowDoubleClick(map: PrtgMapDto): void {
		this.selectedMap = map;
		this.select();
	}
}
